import type { AdapterMeta } from "@repo/adapter-core";

export const MCGRATH_META: AdapterMeta = {
  slug: "mcgrath",
  name: "McGrath",
  baseUrl: "https://www.mcgrath.com.au",
  description: "Premium Sydney and NSW agency with recent sales coverage in NSW, QLD, and ACT.",
  supportedStates: ["NSW", "QLD", "ACT"],
  urlPattern: /mcgrath\.com\.au\/property\/[a-z0-9]+/i,
  sourceType: "agency",
};
